<template>
  <span class="text-ellipsis" :title="mode.value">{{ mode.value }}</span>
</template>

<script setup>
defineProps({
  mode: {
    type: Object,
    required: true,
  },
});
</script>
